var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModalCountrySelection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14587_201106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14587_201106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8888 47.6141C57.8888 47.6141 70.2561 44.9536 84.8529 47.6141V66.9563C84.8529 66.9563 76.7993 61.6354 57.8888 66.9563C57.7263 65.9781 62.5141 55.572 57.8888 47.6141Z",
    fill: "#D33834",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.003 81.7048H40.0692C38.1757 78.6041 34.7605 76.5332 30.8618 76.5332C24.9082 76.5341 20.082 81.3603 20.082 87.314C20.082 93.2676 24.9082 98.0938 30.8618 98.0938C34.7605 98.0938 38.1767 96.0238 40.0692 92.9221H64.003V81.7048Z",
    fill: "#5754E5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1455 39.6328C97.1455 39.6328 82.9082 46.176 74.7109 39.9924V59.3346C74.7109 59.3346 76.5866 62.4907 87.6537 60.8207C97.1455 59.3881 97.1455 59.8378 97.1455 59.8378V39.6328Z",
    fill: "#EF5450",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1436 81.7048H73.2098C71.3164 78.6041 67.9011 76.5332 64.0025 76.5332C58.0488 76.5332 53.2227 81.3594 53.2227 87.313C53.2227 93.2666 58.0488 98.0938 64.0025 98.0938C67.9011 98.0938 71.3173 96.0238 73.2098 92.9221H97.1436V81.7048Z",
    fill: "#807EFE",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.145 98.0928C103.099 98.0928 107.925 93.2665 107.925 87.313C107.925 81.3595 103.099 76.5332 97.145 76.5332C91.1915 76.5332 86.3652 81.3595 86.3652 87.313C86.3652 93.2665 91.1915 98.0928 97.145 98.0928Z",
    fill: "#D1D1FF",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1406 33.377V88.2645",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1442 36.636C98.9443 36.636 100.404 35.1767 100.404 33.3766C100.404 31.5765 98.9443 30.1172 97.1442 30.1172C95.344 30.1172 93.8848 31.5765 93.8848 33.3766C93.8848 35.1767 95.344 36.636 97.1442 36.636Z",
    fill: "#FEC107",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalCountrySelection);
export default __webpack_public_path__ + "static/media/iconModalCountrySelection.9e4902bfa5c9649b26f711a6480d90f3.svg";
export { ForwardRef as ReactComponent };